import Vue from 'vue'
import VueRouter from 'vue-router'
import MainVue from '../views/main/main'

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

const routes = [
  { path: '/', redirect: '/login' },
  {
    path: '/login',
    component: () =>
      import('@/views/login/login')
  },
  {
    path: '/main',
    component: MainVue
  },

  {
    path: '/zhiyuan',
    component: () => import('@/views/main/zhiyuan')
  },

  {
    path: '*',
    component: () =>
      import('@/views/error/notFound')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.VUE_APP_BASE_URL,
  routes
})

export default router
